<template>
  <div
    class="Header--wrapper"
    data-qa="asda-header"
    v-html="headerContent"
  ></div>
</template>

<script>

export default {
  name: 'AsdaHeader',
  data () {
    return {
      headerContent: ''
    }
  },
  beforeMount () {
    this.getHeader()
  },
  methods: {
    async getHeader () {
      try {
        const res = await fetch('/uk/header.html?name=porta')
        this.headerContent = await res.text()
      } catch (error) {
        if (window.newrelic) {
          window.newrelic.noticeError(error)
        }
      }
    }
  }
}
</script>
